import React from "react";
import "./Footer.css";
import BrandWordmark from "./BrandWordmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faFacebookF,
  faWhatsapp,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { PLAY_STORE_URL, WHATSAPP_COMMUNITY_URL } from "../../constants/appLinks";
import { GOOGLE_PLAY_BADGE } from "../../constants/appImages";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="modern-footer">
      {/* Main Footer Content */}
      <div className="modern-footer-container">
        <div className="modern-footer-grid">
          
          {/* Logo and About Section */}
          <div className="modern-footer-logo-section">
            <Link to="/" className="modern-footer-logo">
              <BrandWordmark variant="footer" showTagline />
            </Link>
            <p className="modern-footer-description">
              India's first recruitment portal exclusive for CA, CS, and CMA professionals. Find jobs and hire finance talent.
            </p>
            <div className="modern-footer-app">
              <span className="modern-footer-app-label">Get the app</span>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="modern-footer-play-link"
                aria-label="Get CAJobPortal on Google Play"
              >
                <img
                  src={GOOGLE_PLAY_BADGE}
                  alt="Get it on Google Play"
                  className="modern-footer-play-badge"
                  loading="lazy"
                />
              </a>
            </div>
          </div>

          <div className="modern-footer-links-section modern-footer-jobs-section">
            <h3 className="modern-footer-heading">Browse Jobs</h3>
            <ul className="modern-footer-links-list">
              <li>
                <Link to="/ca-jobs" className="modern-footer-link">
                  <span>CA Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/cs-jobs" className="modern-footer-link">
                  <span>CS Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/cma-jobs" className="modern-footer-link">
                  <span>CMA Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/featured-job" className="modern-footer-link">
                  <span>Featured Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/career-sites" className="modern-footer-link">
                  <span>PSU / Career Site Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/post-job" className="modern-footer-link">
                  <span>Post a Job</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="modern-footer-links-section">
            <h3 className="modern-footer-heading">Quick Links</h3>
            <ul className="modern-footer-links-list">
              <li>
                <Link to="/jobs" className="modern-footer-link">
                  <span>All Jobs</span>
                </Link>
              </li>
              <li>
                <Link to="/about" className="modern-footer-link">
                  <span>About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/contact" className="modern-footer-link">
                  <span>Contact Us</span>
                </Link>
              </li>
              <li>
                <Link to="/faq" className="modern-footer-link">
                  <span>Privacy Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/recruiter" className="modern-footer-link">
                  <span>For Employers</span>
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.cajobportal.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modern-footer-link"
                >
                  <span>Blog</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Connect With Us Section */}
          <div className="modern-footer-social-section">
            <h3 className="modern-footer-heading">Connect With Us</h3>
            <p className="modern-footer-social-description">
              Follow us on social media for updates and job alerts
            </p>
            <div className="modern-footer-social-icons">
              <Link
                to="https://www.facebook.com/cajobportal"
                target="_blank"
                rel="noopener noreferrer"
                className="modern-footer-social-link"
                aria-label="Facebook"
              >
                <div className="modern-footer-social-icon">
                  <FontAwesomeIcon icon={faFacebookF} />
                </div>
              </Link>

              <Link
                to="https://www.linkedin.com/in/cajobportal/?originalSubdomain=in"
                target="_blank"
                rel="noopener noreferrer"
                className="modern-footer-social-link"
                aria-label="LinkedIn"
              >
                <div className="modern-footer-social-icon">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </div>
              </Link>

              <Link
                to="https://twitter.com/cajobportal"
                target="_blank"
                rel="noopener noreferrer"
                className="modern-footer-social-link"
                aria-label="Twitter"
              >
                <div className="modern-footer-social-icon">
                  <FontAwesomeIcon icon={faXTwitter} />
                </div>
              </Link>

              <Link
                to={WHATSAPP_COMMUNITY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="modern-footer-social-link"
                aria-label="WhatsApp Community"
              >
                <div className="modern-footer-social-icon">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="modern-footer-bottom">
        <div className="modern-footer-bottom-container">
          <div className="modern-footer-bottom-content">
            <p className="modern-footer-copyright">
              © {currentYear} CAJobPortal. All rights reserved.
            </p>
            <p className="modern-footer-tagline">
              Empowering CA professionals since 2022
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
